/**
 * "Utils" modules are considered an anti-pattern, for good reason. Do your best to avoid adding to
 * this file :). To belong here, a method must be extremely generic, and fulfill a need not already
 * addressed by JavaScript's standard library or Lodash.
 */

import _ from "lodash";

/**
 * Private function. (Not exported.) Returns a new object where each key in the object, recursively, is replaced with
 * callback(key).
 * NOTE: This object retains arrays as arrays, and does not try to map them into {<index>: <element>} objects.
 * See https://github.com/lodash/lodash/issues/1244.
 * @param {Object}
 * @return {Function}
 */
function mapKeysDeep(object, callback) {
  return _.mapValues(_.mapKeys(object, callback), (value) =>
    _.isObject(value) && !Array.isArray(value) ? mapKeysDeep(value, callback) : value
  );
}

/**
 * @param {Object}
 * @param {Boolean} If true, camelize all keys in the object recursively. If false, camelize only
 *     the top layer. Defaults to true.
 * @return {Object} The input, but with its keys in camelCase. (We run _.camelCase on each key.)
 */
function withKeysCamelized(object, deep = true) {
  if (deep) {
    return mapKeysDeep(object, (_value, key) => _.camelCase(key));
  } else {
    return _.mapKeys(object, (_value, key) => _.camelCase(key));
  }
}

export { withKeysCamelized };
